import {
  createdByServiceUuid,
  nullableCreatedByUserUuid,
  timestamps,
  uuid,
} from '@snap-types/models/common';
import {
  priceStrategySchema,
  productComplexityRankingSchema,
} from '@snap-types/models/enums';
import { snapSuggestionStatusSchema } from '@snap-types/models/sort-status';
import { decimal } from '@snap-types/schemas/decimal';
import { stringToEnum } from '@snap-types/util/enum';
import { z } from 'zod/v4';

export enum InitialMarginSource {
  lastWin = 'lastWin',
  targetContributionMargin = 'targetContributionMargin',
  targetGrossMargin = 'targetGrossMargin',
  calculatedFromLastWinUnitPrice = 'calculatedFromLastWinUnitPrice',
}

export const initialMarginSourceSchema = stringToEnum(InitialMarginSource);

export const columns = {
  uuid,
  lineNumber: z.number().int(),
  specs: z.string().nullish(),

  priceStrategy: priceStrategySchema,

  initialMarginSource: initialMarginSourceSchema.nullish(),
  lastWinOrderLineId: z.string().nullish(),

  leadTimeSuggestionStatus: snapSuggestionStatusSchema,
  suggestedPricesStatus: snapSuggestionStatusSchema,

  automatable: z.boolean(),

  // Lengths match Visual's QUOTE_LINE table columns and are enforced by Postgres itself (see the
  // @db.VarChar() lengths on SnapQuoteLine in schema.prisma)
  leadTimeNotes: z.string().max(80).nullish(),

  configuratorSnapshotUuid: uuid.nullish(),

  customerPartId: z.string().max(30).nullish(),
  finishedPartId: z.string().max(30),

  partUuid: uuid.nullish(),
  serviceChargeUuid: uuid.nullish(),
  snapQuoteVersionUuid: uuid,
  snapWorkOrderUuid: uuid.nullish(),

  priceAdjustment: decimal.nullish(),
  priceAdjustmentAmount: decimal.nullish(),

  productOptionsChangeUnitPrice: z.boolean(),

  productComplexityRanking: productComplexityRankingSchema.nullish(),

  snapQuoteLineImportUuid: uuid.nullish(),

  ...nullableCreatedByUserUuid,
  ...createdByServiceUuid,
  ...timestamps,
};
